import React from 'react';

export default function DesignatedContact() {
  return (<></>);
}